export var ECustomNodeType;
(function (ECustomNodeType) {
    // Root nodes
    ECustomNodeType["ROOT RIGHT"] = "ROOT RIGHT";
    ECustomNodeType["ROOT LEFT"] = "ROOT LEFT";
    ECustomNodeType["ROOT BOTTOM"] = "ROOT BOTTOM";
    // Custom nodes
    ECustomNodeType["CUSTOM LEFT-RIGHT"] = "CUSTOM LEFT-RIGHT";
    ECustomNodeType["CUSTOM TOP-RIGHT"] = "CUSTOM TOP-RIGHT";
    ECustomNodeType["CUSTOM TOP-LEFT"] = "CUSTOM TOP-LEFT";
    ECustomNodeType["CUSTOM TOP-LEFT-BOTTOM ONE"] = "CUSTOM TOP-LEFT-BOTTOM ONE";
    ECustomNodeType["CUSTOM TOP-RIGHT-BOTTOM TWO"] = "CUSTOM TOP-RIGHT-BOTTOM TWO";
    ECustomNodeType["CUSTOM TOP-LEFT-BOTTOM THREE"] = "CUSTOM TOP-LEFT-BOTTOM THREE";
    ECustomNodeType["CUSTOM TOP-RIGHT-BOTTOM FOUR"] = "CUSTOM TOP-RIGHT-BOTTOM FOUR";
    ECustomNodeType["CUSTOM TOP-RIGHT-BOTTOM-LEFT ONE"] = "CUSTOM TOP-RIGHT-BOTTOM-LEFT ONE";
    ECustomNodeType["CUSTOM TOP-RIGHT-BOTTOM-LEFT TWO"] = "CUSTOM TOP-RIGHT-BOTTOM-LEFT TWO";
    // Destination nodes
    ECustomNodeType["DESTINATION RIGHT"] = "DESTINATION RIGHT";
    ECustomNodeType["DESTINATION LEFT"] = "DESTINATION LEFT";
    ECustomNodeType["DESTINATION TOP"] = "DESTINATION TOP";
})(ECustomNodeType || (ECustomNodeType = {}));
export var ESwitchType;
(function (ESwitchType) {
    ESwitchType["Animate"] = "Animate";
    ESwitchType["Add Label"] = "Add Label";
    ESwitchType["Start Arrow"] = "Start Arrow";
    ESwitchType["End Arrow"] = "End Arrow";
    ESwitchType["Label Input"] = "Label Input";
})(ESwitchType || (ESwitchType = {}));
